import en from "./en.json";
import ar from "./ar.json";
import aiAssistant from "./aiAssistant.json";
import { I18nLocaleEnum } from "./../enums/locale.enum";

export const defaultLocale = I18nLocaleEnum.EN;

export const languages = {
  en: { ...en, aiAssistant: aiAssistant.en },
  ar: { ...ar, aiAssistant: aiAssistant.ar },
};
